module.exports = __webpack_public_path__ + "img/closed-deposit-outline-blue.3c1e77fc.svg";